import { render, staticRenderFns } from "./update-role.vue?vue&type=template&id=1e28b066"
import script from "./update-role.vue?vue&type=script&lang=ts"
export * from "./update-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports